import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { S25ProgressBarComponent } from "./s25.progress.bar.component";

import { S25IconComponent } from "../s25-icon/s25.icon.component";

@NgModule({
    imports: [CommonModule, S25IconComponent],
    declarations: [S25ProgressBarComponent],
    exports: [S25ProgressBarComponent],
    providers: [S25ProgressBarComponent],
})
export class S25ProgressBarModule {}
